import { Moment } from 'moment'

export type NumberXYValues = {
	total: number
	afterDot: number
	allowNegative?: boolean
}

export enum InputTypes {
	formula = 'formula',
	integer = 'integer',
	numberXY = 'numberXY'
}

export type CalendarType = [Moment | null, Moment | null]
export type CalendarCb = CalendarType | null
